import moment from 'moment';

export default {
    props: ['assignment'],
    template: '<div class="alert alert-danger countdown">{{assignment.name}} is due in {{countdown}}</div>',
    data() {
        return {
            countdown: null
        }
    },
    mounted() {
        var self = this;
        this.startCountdown();
        window.setInterval(function() {
            self.startCountdown();
        }, 1000)
    },
    methods: {
        startCountdown: function() {
            var now = new Date();
            var duration = moment.duration(moment(this.assignment.time_due).diff(moment(now)));

            var days = moment(moment.duration(duration._milliseconds)._data).format("D");
            var hours = moment(moment.duration(duration._milliseconds)._data).format("H");
            var minutes = moment(moment.duration(duration._milliseconds)._data).format("m");
            var seconds = moment(moment.duration(duration._milliseconds)._data).format("s");

            this.countdown = days + ' days ' + hours + ' hours ' + minutes + ' minutes and ' + seconds + ' seconds';
        }
    }

};


// WEBPACK FOOTER //
// ./src/components/reusable/assignment-countdown/index.js